/******************************************************************************
 * We will use the following regexp to strip away illegal characters from
 * a query result. 
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var ILLEGAL_TOKEN_REGEX = /\u2028|\u2029/g;

exports['default'] = function () {
  var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  return JSON.parse(JSON.stringify(obj).replace(ILLEGAL_TOKEN_REGEX, ''));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/sanitize.js
// module id = 9eBf
// module chunks = 15